import React from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/svg/filter.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import ChartOptionsSidebar from "./ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "./ChartsOptionsSidebar/CustomCheckBox";

export const ChartFilterIcon = (props) => {
    let topChartName = "";
    let widgetArr = props.widgetListDashboardCurrent && Object.values(props.widgetListDashboardCurrent);
    widgetArr?.map((w) => {
        if (w && w.widget_filter.layout.x == 0 && w.widget_filter.layout.y == 0) {
            topChartName = w.name;
        }
    });
    return (
        <Popup
            content={props.chartFilterApplied ? "Chart Filters Applied" : "Apply Chart Filters"}
            position="bottom center"
            size="tiny"
            inverted
            className="skiptranslate"
            trigger={
                <div data-html2canvas-ignore="true" className={`chart-header-icon ${topChartName && topChartName == props.name ? "dashboard_step14" : ""}`}>
                    <FilterIcon
                        className={`chart-filter ${props.chartFilterApplied ? "chart-filter-applied" : ""}`}
                        onClick={(e) => props.changeShowChartFilterOptions(e)}
                    />
                </div>
            }
            style={{ zIndex: "99999" }}
        />
    );
};

export const ChartFilterOptions = (props) => {
    return (
        props.showChartFilterOptions && (
            <ChartOptionsSidebar showMoreOptionsLoc={props.showMoreOptionsLoc} changeShowMoreOptions={props.changeShowChartFilterOptions}>
                <div className="chart-filter-change  menu-option" onClick={props.changeChartFilter}>
                    <span>Change Chart Filter</span>
                </div>
                <CustomCheckBox
                    className="apply-chart-filters"
                    checked={props.chartFilterApplied}
                    onClick={props.toggleChartFilterApplied}
                    label="Apply Chart Filters"
                    disabled={!props.chartFilterSaved}
                />
            </ChartOptionsSidebar>
        )
    );
};
